export default "<p>bank-summary-table works!</p>\n"